/**
 * Terms of Service - English v1
 * 
 * Source: public/terms.html (Official Pi Network submission)
 */
export const TERMS_V1_EN = {
    version: "v1",
    effectiveDate: "2025-10-15",
    language: "en",
    title: "Terms of Service",
    content: `
Terms of Service for Spot Go

Last Updated: October 15, 2025 (KST)

These Terms of Service ("Terms") govern your use of the Spot Go game ("Service") provided by the Developer ("we," "us," or "our"). By accessing or using the Service, you agree to be bound by these Terms.

1. Accounts

Your account is linked to your Pi Network identity. You are responsible for all activities that occur under your account, including ensuring compliance with these Terms.

1-1. Public Display and Storage of Nicknames

Your Pi Network nickname and user ID are received through the Pi Network login process and securely stored on our servers. These identifiers are used to maintain your account, display rankings (e.g., leaderboards and events), and verify payment history. Your nickname may be publicly displayed to other users within the Service. Other personal or payment information is never shared with other players.

2. Virtual Goods

The Service may include virtual goods ("Virtual Goods"). These are not real-world currency. Except as required by applicable law, all purchases of Virtual Goods are final and non-refundable. We have the absolute right to manage, regulate, control, modify, or eliminate Virtual Goods at any time, with or without notice. We shall have no liability to you or any third party if we exercise such rights.

3. User Conduct

You agree not to misuse the Service. This includes, but is not limited to: cheating, exploiting bugs, using automation software (bots), decompiling the software, or attempting to disrupt the integrity of the Service.

4. Intellectual Property

The Service, including all of its content, features, and functionality, is the exclusive property of the Developer. You are granted a limited, non-exclusive, non-transferable license to access and use the Service for your personal, non-commercial use.

5. Termination

We may terminate or suspend your access to our Service immediately, without prior notice or liability, if you breach the Terms. Termination of your access will result in the immediate and permanent deletion of all your game data associated with our Service.

6. Disclaimer of Warranties; Limitation of Liability

The Service is provided on an "AS IS" and "AS AVAILABLE" basis. To the fullest extent permissible by law, we disclaim all warranties of any kind. To the fullest extent permissible by law, the Developer shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of, or inability to use, the Service.

7. Governing Law and Dispute Resolution

These Terms shall be governed by the laws of the Republic of Korea, without regard to its conflict of law provisions. Any dispute arising out of or in connection with these Terms shall be submitted to the exclusive jurisdiction of the Suwon District Court.

8. Changes to Terms

We reserve the right to modify these Terms at any time. We will provide notice of changes by posting the new Terms within the Service or on our official website.

9. Contact Us

If you have any questions, please contact us at: lukep81@painori.com
`.trim()
};
